import Header from "../../Layouts/Components/Header";
import { useKeycloak } from "@react-keycloak/web";
const Overview = () => {
  const { keycloak } = useKeycloak();
  return (
    <div>
      <Header headLine="Overview" />
      Welcome back, {keycloak.tokenParsed.name}
    </div>
  );
};

export default Overview;
